import React, { Fragment, useEffect, useState, useMemo } from 'react'
import TitleBar from '../../../components/Elements/TitleBar'
import DatePickerRange from '../../../components/Elements/DatePickerRange'
import DateFilterTabs from '../../../components/Elements/DateFilterTabs'
import TableComponent from '../../../components/Elements/Table'
import TablePagination from '../../../components/Elements/TablePagination'
import AvatarMemberComponent from '../../../components/Elements/AvatarMember'
import { Divider } from 'antd'
import moment from 'moment'
import NumberWithCommas from '../../../utils/NumberWithCommas'
import useDateRange from "../../../hooks/useDateRange"
import useFetchReport from '../../../hooks/useFetchReport'
import { BonusSummary, BonusTransactions } from '../../../@types/report'
import useDatePagination from '../../../hooks/useDatePagination'
import useFetchReportSummary from '../../../hooks/useFetchReportSummary'

const ReportBonus = () => {
    const { dateRange, setDateRange } = useDateRange()
    const [dataSource, setDataSource] = useState<any>([])
    const [dataTransactionsSource, setDataTransactionsSource] = useState<any>([])

    const { pagination, setPagination } = useDatePagination()
    const { data: dataSummary, isLoading: isLoadingSummary  } = useFetchReportSummary<BonusSummary>('promotion/summary', dateRange, 10000)
    const { data, mutate, isLoading } = useFetchReport<BonusTransactions>('promotion', dateRange, 10000, { page: pagination.page, limit: pagination.pageSize })

    const columnsSummary: any = [
        {
            title: 'โบนัส',
            dataIndex: 'Name',
        },
        {
            title: 'จำนวนครั้ง',
            dataIndex: 'Count',
            render: (text: any, record: any) => (
                <div className="row-amount" style={{ minWidth: '56px'}}>
                    {NumberWithCommas(record.Count)}
                </div>
            )
        },
        {
            title: 'จำนวนเงิน',
            dataIndex: 'Amount',
            render: (text: any, record: any) => (
                <div className="row-amount">
                    <span>฿</span> {NumberWithCommas(record.Amount, 2)}
                </div>
            )
        }
    ]

    const columnsTransactions: any = [
        {
            title: 'เวลา',
            dataIndex: 'createdAt',
            width: '140px',
            render: (text: any, record: any) => (
                <div className="row-datetime">
                    <div><span>{moment(record.createdAt).format('DD/MM/YYYY')}</span></div>
                    <div>{moment(record.createdAt).format('HH:mm:ss')}</div>
                </div>
            )
        },
        {
            title: 'สมาชิก',
            dataIndex: 'name',
            render: (text: any, record: any) => (
                <>
                    <AvatarMemberComponent
                        fullname={`${record.member.firstName} ${record.member.lastName}`}
                        phone={record.member.phone}
                        search={true}
                    />
                </>
            )
        },
        {
            title: 'โบนัส',
            dataIndex: 'bonus',
            render: (text: any, record: any) => (
                <>
                    {record.promotion.name}
                </>
            )
        },
        {
            title: 'จำนวนเงิน',
            dataIndex: 'amount',
            render: (text: any, record: any) => (
                <div className="row-amount">
                    <span>฿</span> {NumberWithCommas(record.amount, 2)}
                </div>
            )
        },
        {
            title: 'ยอดเทิร์น',
            dataIndex: 'totalTurn',
            render: (text: any, record: any) => (
                <div className="row-amount">
                    <span>฿</span> {NumberWithCommas(record.totalTurn, 2)}
                </div>
            )
        },
        {
            title: 'เทิร์น',
            dataIndex: 'turn',
            render: (text: any, record: any) => (
                <>
                    {record.turn} เท่า
                </>
            )
        }
    ]

    useEffect(() => {
        setDataSource([])
        
        if (dataSummary !== undefined ) {
            setDataSource(Object.values(dataSummary).map((item: any) => item))
        }
        // setLoading(isLoading)
    }, [ dataSummary, isLoadingSummary, setDataSource])

    useEffect(() => {
        setDataTransactionsSource([])
        if (data !== undefined) {
            if (data.transactions.length > 0) {
                setDataTransactionsSource(data.transactions)
            }
        }
        // setLoading(isLoading)
    }, [data, isLoading, setDataTransactionsSource])

    useMemo(() => {
        // setLoading(true)
        mutate()
    }, [setDateRange, setPagination]) // eslint-disable-line
    
    return (
        <Fragment>
            <TitleBar title="รายงานโบนัส" />

            <div className="d-lg-flex justify-content-lg-between d-md-flex justify-content-md-between mb-4">
                <DatePickerRange onChangeDate={setDateRange} onDateActive={dateRange} />
                <DateFilterTabs onChangeDate={setDateRange} onDateActive={dateRange} />
            </div>
            <h5 className="mt-5 mb-3">รายงานการรับโบนัสแต่ละประเภท</h5>
            <div className="box-white ant-box-table">
                <TableComponent
                    columns={columnsSummary}
                    dataSource={dataSource || []}
                    loading={isLoadingSummary}
                />
            </div>
            <Divider />
            <h5 className="mt-5 mb-3">รายงานการรับโบนัส <small className="sub-title">{`${NumberWithCommas(data?.pagination.Count)} รายการ`}</small></h5>
            <div className="box-white ant-box-table">
                <TablePagination
                    columns={columnsTransactions}
                    dataSource={dataTransactionsSource || []}
                    loading={isLoading}
                    totalCount={data?.pagination.Count || 0}
                    currentPage={pagination.page}
                    onChangePagination={setPagination}
                />
            </div>
        </Fragment>
    )
}

export default ReportBonus